import React, { FC, ReactElement, cloneElement } from "react";
import { Transition } from "react-transition-group";

import { TransitionProps } from "../types";

interface ISlide extends Omit<TransitionProps, "timeout"> {
  children: ReactElement;
  timeout?: number;
  initialDirection?: string;
}

export const Slide: FC<ISlide> = ({
  in: inProp = false,
  children,
  style,
  timeout = 300,
  initialDirection = "left",
  ...rest
}) => {
  let directionSign: string;

  switch (initialDirection) {
    case "right":
      directionSign = "100%, 0";
      break;
    case "top":
      directionSign = "0, -100%";
      break;
    case "bottom":
      directionSign = "0, 100%";
      break;
    default:
      directionSign = "-100%, 0";
  }

  const defaultStyle = (timeout: number): Partial<{ transition: string }> => ({
    transition: `all ${timeout}ms ease`,
  });

  const transitionStyles = {
    entering: {
      transform: `translate(0,0)`,
    },
    entered: {
      transform: `translate(0,0)`,
    },
    exiting: {
      transform: `translate(${directionSign})`,
    },
    exited: {
      transform: `translate(${directionSign})`,
    },
  };

  return (
    <Transition in={inProp} timeout={timeout} {...rest}>
      {(state): ReactElement => {
        return cloneElement(children, {
          style: {
            visibility: state === "exited" && !inProp ? "hidden" : undefined,
            ...defaultStyle(timeout),
            ...transitionStyles[state],
            ...style,
            ...children.props.style,
          },
        });
      }}
    </Transition>
  );
};

Slide.displayName = "Slide";
